export default __webpack_public_path__ + "static/media/tediousForm.be113afc.jpg";